import React, { useEffect, useState } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
// import Gap from "../../../components/Gap";
// import Circle from "../../../components/appLoading/circle";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import NavigateNextIcon from "@material-ui/icons/NavigateNext";
// import IconButton from "@material-ui/core/IconButton";
// import WhatsAppIcon from "@material-ui/icons/WhatsApp";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import ListSubheader from "@material-ui/core/ListSubheader";
import useStyles from "./style";
import { Skeleton } from "@material-ui/lab";
import { Avatar, Button } from "@material-ui/core";

function ListPendaftaran() {
  const classes = useStyles();
  const { subdomain } = useData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getlistpendaftar");

      const res = await func({ domain: subdomain?.id });

      setData(res?.data ?? []);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // console.log(data);

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  const handleWa = (no, nama) => {
    const text = `halo kak ${nama}, apa masih punya pertanyaan terkait registrasi di tokorame?`;

    window.open(`https://wa.me/?text=${text}&phone=${no?.replace("+", "")}`);
  };

  if (loading) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (data?.length < 1) {
    return (
      <Typography
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          marginTop: "2.5%",
          fontWeight: "bold",
        }}
      >
        Tidak Ada Data
      </Typography>
    );
  }

  return (
    <List>
      {data &&
        data
          ?.sort((a, b) => {
            const x = a?.transaction_time;
            const y = b?.transaction_time;
            if (x > y) {
              return -1;
            }
            if (y > x) {
              return 1;
            }
            return 0;
          })
          ?.map((item, index) => {
            const tgl = item?.transaction_time;
            const dates = new Date(tgl?._seconds * 1000);
            const newCreated_at = `${dates.getFullYear()}-${pad2(
              dates.getMonth() + 1
            )}-${pad2(dates.getDate())}`;

            const newDate = `${new Date().getFullYear()}-${pad2(
              new Date().getMonth() + 1
            )}-${pad2(new Date().getDate())}`;

            if (index < 3) {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: "3%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "1.5%",
                      width: "50%",
                    }}
                  >
                    <Avatar className={classes.medium}>
                      <AccountCircleIcon style={{ width: 40, height: 40 }} />
                    </Avatar>
                    <div style={{ marginLeft: "1.5%" }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap={true}
                            style={{
                              fontSize: 15,
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.nama}
                          </Typography>
                        </div>
                        {/* <div
                            style={{
                              backgroundColor: "#FED0E0",
                              borderRadius: 4,
                              marginLeft: 8,
                              justifyContent: "center",
                            }}
                          >
                            <text
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                                margin: "3px",
                                fontVariant: "small-caps",
                                color: "#f44336",
                              }}
                            >
                              {item?.tipe_akun}
                            </text>
                          </div> */}
                      </div>
                      <div>
                        <Typography style={{ fontSize: 13 }}>
                          {tgl ? newCreated_at : "-"}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "50%",
                      // marginRight: "1,5%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "inline-grid" }}>
                      <Button
                        style={{ marginRight: "10px", marginLeft: "10px" }}
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          handleWa(item.wa, item?.nama);
                        }}
                      >
                        <Typography
                          noWrap={true}
                          variant="button"
                          style={
                            {
                              // fontSize: 15,
                              // fontWeight: "bold",
                              // textTransform: "capitalize",
                            }
                          }
                        >
                          CHAT {item.wa}{" "}
                        </Typography>
                        {/* <Typography style={{ fontSize: 13 }}>
                          {item?.wa}
                        </Typography> */}
                      </Button>
                    </div>
                    {/* <div
                        style={{
                          marginLeft: "1.5%",
                          marginRight: "1.5%",
                        }}
                      >
                        <DoubleArrowIcon
                          color="secondary"
                          style={{
                            // backgroundColor:"pink",
                            transform: "rotate(-90deg)",
                          }}
                        />
                      </div> */}
                  </div>
                </div>
              );
            }
            return null;

            {
              /* return (
              <ListItem
                key={index}
                button
                onClick={() => handleWa(item?.wa, item?.nama)}
              >
                <ListItemText
                  primary={
                    <Typography className={classes.liquidPrimaryCa}>
                      {item?.nama}
                    </Typography>
                  }
                  secondary={
                    !item?.wa ? (
                      <Typography className={classes.liquidPrimary}>
                        tidak ada nomor
                      </Typography>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <WhatsAppIcon className={classes.liquidWa} />
                        <Gap width={10} />
                        <Typography className={classes.liquidWa}>
                          {item?.wa}
                        </Typography>
                      </div>
                    )
                  }
                />
                <ListItemText
                  primary={
                    <Typography className={classes.liquidOrange}>
                      {item?.level}
                    </Typography>
                  }
                  secondary={
                    <Typography className={classes.liquidSecondList}>
                      {tgl?newCreated_at:null}
                    </Typography>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton>
                    <NavigateNextIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ); */
            }
          })}
    </List>
  );
}

export default ListPendaftaran;
